var React = require('react');

function TabButton (props) {
    return React.createElement("svg",props,[React.createElement("style",{"type":"text/css","key":0},"\n\t#tab_button_bg.st0 {\n\t\topacity: 0.905;\n\t\tfill: #FFFFFF;\n\t}\n\t#tab_button_line.st1 {\n\t\tfill: none;\n\t\tstroke: #C0B57C;\n\t\tstroke-width: 0.5;\n\t}\n"),React.createElement("path",{"id":"tab_button_bg","className":"st0","d":"M0,73.2C0,116.8,29.9,144,116,144c90,0,116-32.6,116-70.8C232,25.7,191.8,0,116,0C30.7,0,0,27,0,73.2z","key":1}),React.createElement("path",{"id":"tab_button_line","className":"st1","d":"M5.2,73.9c0,40.8,28.5,66.4,110.5,66.4c85.7,0,110.5-30.6,110.5-66.4c0-44.5-38.3-68.6-110.5-68.6\n\tC34.5,5.2,5.2,30.5,5.2,73.9z","key":2})]);
}

TabButton.defaultProps = {"version":"1.1","id":"button","x":"0px","y":"0px","viewBox":"0 0 232 144","style":{"enableBackground":"new 0 0 232 144"},"xmlSpace":"preserve"};

module.exports = TabButton;

TabButton.default = TabButton;
